import { TopicShortcut } from '../../../../../models/channels/types';
import { Shortcut as OldShortcut } from '../../../../ui/shortcut/old';
import { Shortcut } from '../../../../ui/shortcut';
import useFeatureFlag from '../../../../../common/use-feature-flag';
import { Feature } from '../../../../../models/features/features';
import { mapShortcutLinks } from './mapShortcutLinks';

type TopicPageShortcutProps = {
  shortcut: TopicShortcut;
};

export function TopicPageShortcut({ shortcut }: TopicPageShortcutProps) {
  const notificationCenterEnabled = useFeatureFlag(
    Feature.NOTIFICATION_CENTER_ENABLED
  );
  const allowRiskyLinksEnabled = useFeatureFlag(
    Feature.KNOWLEDGE_HUB_ALLOW_RISKY_LINKS
  );

  const links = mapShortcutLinks(
    shortcut.links,
    Boolean(allowRiskyLinksEnabled)
  );

  return notificationCenterEnabled ? (
    <Shortcut
      label={shortcut.name}
      description={shortcut.description}
      imgSrc={shortcut.icon_url}
      links={links}
    />
  ) : (
    <OldShortcut
      label={shortcut.name}
      description={shortcut.description}
      imgSrc={shortcut.icon_url}
      links={links}
    />
  );
}
